import { lazyPage } from "@/router/lazyPage";

export const ChecklistModel = lazyPage(
  () => import("@/pages/ChecklistModel/ChecklistModel"),
  "ChecklistModel",
);
export const DocumentCategory = lazyPage(
  () => import("@/pages/DocumentCategory/DocumentCategory"),
  "DocumentCategory",
);
export const EquipmentCategories = lazyPage(
  () => import("@/pages/Settings/Equipments/EquipmentCategories"),
  "EquipmentCategories",
);
export const FinancialCategories = lazyPage(
  () => import("@/pages/Settings/FinanceLookups/FinancialCategories"),
  "FinancialCategories",
);
export const MaterialCategories = lazyPage(
  () => import("@/pages/Settings/Materials/MaterialCategories"),
  "MaterialCategories",
);
export const MeasurementUnits = lazyPage(
  () => import("@/pages/Settings/Materials/MeasurementUnits"),
  "MeasurementUnits",
);
export const Occurrence = lazyPage(() => import("@/pages/Occurrence/Occurrence"), "Occurrence");
export const Partners = lazyPage(() => import("@/pages/Settings/Partners/Partners"), "Partners");
export const PaymentMethods = lazyPage(
  () => import("@/pages/Settings/FinanceLookups/PaymentMethods"),
  "PaymentMethods",
);
export const PhotoTagsSettings = lazyPage(() => import("@/pages/PhotoTags/PhotoTags"), "PhotoTags");
export const ProjectBudgetStatuses = lazyPage(
  () => import("@/pages/Settings/Lookups/ProjectBudgetStatuses"),
  "ProjectBudgetStatuses",
);
export const ProjectClientBudgetStatuses = lazyPage(
  () => import("@/pages/Settings/Lookups/ProjectClientBudgetStatuses"),
  "ProjectClientBudgetStatuses",
);
export const ProjectPriorities = lazyPage(
  () => import("@/pages/Settings/Lookups/ProjectPriorities"),
  "ProjectPriorities",
);
export const ProjectStatuses = lazyPage(
  () => import("@/pages/Settings/Lookups/ProjectStatuses"),
  "ProjectStatuses",
);
export const ProjectTypes = lazyPage(
  () => import("@/pages/Settings/Lookups/ProjectTypes"),
  "ProjectTypes",
);
export const ServiceFrontDeadlineStatuses = lazyPage(
  () => import("@/pages/Settings/Lookups/ServiceFrontDeadlineStatuses"),
  "ServiceFrontDeadlineStatuses",
);
export const ServiceFrontModel = lazyPage(
  () => import("@/pages/ServiceFrontModel/ServiceFrontModel"),
  "ServiceFrontModel",
);
export const SettingsDiaryReportModels = lazyPage(
  () => import("@/pages/Settings/DiaryReportModels/SettingsDiaryReportModels"),
  "SettingsDiaryReportModels",
);
export const SettingsEquipments = lazyPage(
  () => import("@/pages/Settings/Equipments/SettingsEquipments"),
  "SettingsEquipments",
);
export const SettingsHome = lazyPage(() => import("@/pages/Settings/SettingsHome"), "SettingsHome");
export const SettingsMaterials = lazyPage(
  () => import("@/pages/Settings/Materials/SettingsMaterials"),
  "SettingsMaterials",
);
export const SettingsGeneral = lazyPage(
  () => import("@/pages/Settings/SettingsGeneral"),
  "SettingsGeneral",
);
export const SettingsOrganization = lazyPage(
  () => import("@/pages/Settings/SettingsOrganization"),
  "SettingsOrganization",
);
export const SettingsBilling = lazyPage(
  () => import("@/pages/Settings/SettingsBilling"),
  "SettingsBilling",
);
export const SettingsServiceTaxCodes = lazyPage(
  () => import("@/pages/Settings/Fiscal/SettingsServiceTaxCodes"),
  "SettingsServiceTaxCodes",
);
export const SettingsPermissionTemplates = lazyPage(
  () => import("@/pages/Settings/SettingsPermissionTemplates"),
  "SettingsPermissionTemplates",
);
export const SettingsShell = lazyPage(
  () => import("@/pages/Settings/SettingsShell"),
  "SettingsShell",
);
export const SettingsUsers = lazyPage(
  () => import("@/pages/Settings/SettingsUsers"),
  "SettingsUsers",
);
export const Worker = lazyPage(() => import("@/pages/Worker/Worker"), "Worker");
export const WorkerRoles = lazyPage(
  () => import("@/pages/Settings/Workers/WorkerRoles"),
  "WorkerRoles",
);
